/**
 * Serialisierbares Format eines Drumpatterns.
 *
 * Das Format ist bewusst eine flache, JSON-taugliche Struktur ohne
 * Klassen oder Verhalten, damit es unveraendert in localStorage
 * abgelegt werden kann.
 */

import {
  HitType,
  STEP_COUNT,
  type DrumInstrument,
  type StepIndex,
  type Sticking,
  type Subdivision,
} from './types';

/**
 * Aktuelle Versionsnummer des Speicherformats.
 * Wird bei kuenftigen Aenderungen erhoeht.
 */
export const PATTERN_FORMAT_VERSION = 2;

/**
 * Ein serialisierter Einzelschlag.
 */
export interface SerializedHit {
  readonly instrument: DrumInstrument;
  /** Ganzzahliger Tick (0..47) in Format v2; Sechzehntelindex in v1. */
  readonly step: StepIndex;
  readonly type: HitType;
}

/**
 * Vollstaendige serialisierte Repraesentation eines Patterns.
 */
export interface SerializedPattern {
  readonly version: number;
  readonly bars: number;
  readonly timeSignature: {
    readonly numerator: number;
    readonly denominator: number;
  };
  readonly stepCount: number;
  readonly hits: readonly SerializedHit[];
  readonly subdivisions?: readonly Subdivision[];
  readonly sticking?: readonly Sticking[];
}

/**
 * Feste Meta-Eigenschaften des DP-1-Patterns.
 */
export const PATTERN_META = {
  bars: 1,
  timeSignature: { numerator: 4, denominator: 4 },
  stepCount: STEP_COUNT,
} as const;
